import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const selectSelectedContent = (state: RootState) =>
  state.content.selectedContent;

export const selectIsContentModalOpen = (state: RootState) =>
  state.content.isModalOpen;

export const selectIsContentModalOpenedForAdd = (state: RootState) =>
  state.content.isModalOpenedForAdd;

export const selectFormHasErrors = createSelector(
  (state: RootState) => state.content.validationErrors,
  (validationErrors) =>
    validationErrors
      ? Object.keys(validationErrors).some(
          (field) => validationErrors[field].length > 0
        )
      : false
);

export const selectValidationErrors = (state: RootState) =>
  state.content.validationErrors;

export const selectFieldErrors = (field: string) =>
  createSelector(
    [selectValidationErrors],
    (validationErrors) => validationErrors[field] || []
  );
